import { METABASE_INSTANCE_URL } from "@/lib/metabase";
import { useSession } from "@supabase/auth-helpers-react";
import { useEffect, useState } from "react";
import type { MetabaseGuestEmbedProps } from "../../types";
import { MetabaseEmbedFrame } from "./MetabaseEmbedFrame";
export const MetabaseGuestEmbed = (props: MetabaseGuestEmbedProps) => {
  const instanceUrl = props.namespace ? `https://${props.namespace}.metabaseapp.com` : METABASE_INSTANCE_URL;
  const session = useSession();
  const [token, setToken] = useState<string>();
  const [error, setError] = useState<string>();
  useEffect(() => {
    if (!session?.access_token) return;
    let cancelled = false;
    const fetchToken = async () => {
      try {
        const response = await fetch("/api/metabase/guest-embed-token", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${session.access_token}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            embedPageId: props.embedPageId
          })
        });
        const data = (await response.json().catch(() => null)) as {
          token?: string;
          error?: string;
        } | null;
        if (cancelled) return;
        if (!response.ok || !data?.token) {
          setError(data?.error || "Could not load the embedded dashboard.");
          return;
        }
        setToken(data.token);
      } catch (e) {
        console.error("Metabase guest embed token request failed:", e);
        if (!cancelled) setError("Could not load the embedded dashboard.");
      }
    };
    fetchToken();
    return () => {
      cancelled = true;
    };
  }, [session?.access_token, props.embedPageId]);
  if (error) {
    return <>{error}</>;
  }
  return <MetabaseEmbedFrame token={token} instanceUrl={instanceUrl} data-sentry-element="MetabaseEmbedFrame" data-sentry-component="MetabaseGuestEmbed" data-sentry-source-file="MetabaseGuestEmbed.tsx" />;
};